import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive } from 'vue';

import { sendCode } from "@/api/form";


export default /*#__PURE__*/_defineComponent({
  __name: 'RenderValidate',
  props: ['item'],
  emits: ['handle'],
  setup(__props, { emit: emits }) {

const props = __props;



const state: any = reactive({
  leftTime: 0,
  timer: null,
})

async function getCode() {
  emits('handle', {
    type: 'validate',
    fieldId: props.item.fieldId,
    cb: startTimer,
  });
}

function startTimer() {
  state.leftTime = 60;

  state.timer = setInterval(() => {
    if (state.leftTime <= 0) {
      clearInterval(state.timer);
      
      return
    }
    
    --state.leftTime;
  }, 1 * 1000);
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    append: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: getCode,
        style: {"width":"140px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(state.leftTime ? `${state.leftTime}秒后重新获取` : '获取验证码'), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16))
}
}

})